import getLocal from '@/app/utils/getLocal';
import classNames from 'classnames';
import React from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EfImg from 'elem/ui/ef-img';
import EfLink from 'elem/ui/ef-link';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import { ThemeWBProps } from 'eco-design-micro/props/const';

import { langText } from './langText';
import './index.scss';

export interface EfSwiperBItemProps {
    /**
     * 图片
     */
    pc: string;
    /**
     * 跳转链接
     */
    href: string;
    /**
     * 标题
     */
    title?: string;
    /**
     * 主题色
     */
    theme?: ThemeWBProps;
}
interface EfSwiperBProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 列表
     */
    items?: EfSwiperBItemProps[];
    theme?: ThemeWBProps;
}

/**
 *
 * 左右划动卡片
 */
const EfSwiperB: React.FC<EfSwiperBProps> = ({ items = [], className, theme }) => {
    const { locale = 'us' } = getLocal();
    const textA = langText[locale] || langText['us']; //卡片内非传入文本
    const prefixCls = `ef-swiper-link`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });

    return (
        <div className={classes}>
            <Swiper
                className={`${prefixCls}-list`}
                spaceBetween={0}
                slidesPerView={'auto'}
                initialSlide={0}
                navigation={{
                    nextEl: '.eco-swiper-button-next',
                    prevEl: '.eco-swiper-button-prev',
                }}
                modules={[Navigation]}
            >
                {items?.map((item: EfSwiperBItemProps, k: number) => (
                    <SwiperSlide className={`${prefixCls}-item`} key={k}>
                        <div className={`${prefixCls}-item-img`}>
                            <EfImg pc={item?.pc} alt={item?.title} />
                        </div>
                        <div className={`${prefixCls}-item-msg`}>
                            <p className={`${prefixCls}-item-name`}>{item?.title}</p>
                            {item?.href ? (
                                <EfLink className={`${prefixCls}-item-link`} href={item?.href}>
                                    {textA.link_more}
                                    <span className={`${prefixCls}-arrow`}></span>
                                </EfLink>
                            ) : (
                                <span className={`${prefixCls}-item-link`}> {textA.text_link}</span>
                            )}
                        </div>
                    </SwiperSlide>
                ))}
                <div className={`eco-swiper-control eco-swiper-control-${theme}`}>
                    <div className="eco-swiper-navigation">
                        <div className="eco-swiper-button-prev">
                            <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                        </div>
                        <div className="eco-swiper-button-next">
                            <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                        </div>
                    </div>
                </div>
            </Swiper>
        </div>
    );
};

export default EfSwiperB;
